import Cut16 from '@carbon/icons-react/es/cut/16';
import Edit16 from '@carbon/icons-react/es/edit/16';
import OverflowMenuVertical16 from '@carbon/icons-react/es/overflow-menu--vertical/16';
import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Dropdown, Tooltip } from 'antd';
import React, { FC } from 'react';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import { store } from 'data';
import { useTranslate } from 'hooks/use-translation';
import { queryClient } from 'queries';

const SmallButton = styled(Button)`
  height: 24px !important;
  width: 24px !important;
  min-width: 24px !important;
`;

interface Props {
  hideSplit: boolean;
  onSplit: () => void;
  onRemove: () => void;
  onEdit: () => void;
  translate: ReturnType<typeof useTranslate>;
}

export const EventMoreDropdown: FC<Props> = ({
  onSplit,
  onRemove,
  onEdit,
  hideSplit,
  translate,
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Dropdown
          className="more-actions"
          overlay={
            <Menu>
              <Menu.Header>
                <span>{translate('more_actions')}</span>
              </Menu.Header>
              <Menu.Item key="edit" icon={<Edit16 />} onClick={onEdit}>
                {translate('edit')}
              </Menu.Item>
              {hideSplit ? null : (
                <Menu.Item key="split" icon={<Cut16 />} onClick={onSplit}>
                  {translate(
                    'resource_management.allocations.actions.split_time',
                  )}
                </Menu.Item>
              )}
              <Menu.Divider />
              <Menu.Item
                key="remove"
                danger
                icon={<TrashCan16 />}
                onClick={onRemove}
              >
                {translate(
                  'resource_management.allocations.actions.delete_allocation',
                )}
              </Menu.Item>
            </Menu>
          }
          placement="bottomLeft"
          trigger={['click']}
        >
          <Tooltip title={translate('more_actions')}>
            <SmallButton
              type="primary"
              icon={<OverflowMenuVertical16 />}
              size="small"
              data-cy="buttons.more-actions"
            />
          </Tooltip>
        </Dropdown>
      </Provider>
    </QueryClientProvider>
  );
};
